import { memo } from "react";
import Skeleton from "../../components/Skeleton";

const COLUMN_COUNT = 9; // Compare, Shape, Media, Price, Carat, Color, Clarity, Cut, Action

function DiamondListSkeleton({ rows = 8 }) {
    return (
        <div>
            <div className="flex border">
                <div className="w-full doc-table-container m-0 p-0">
                    <table className="w-full">
                        <thead className="border-b">
                            <tr>
                                {Array.from({ length: COLUMN_COUNT }).map((_, i) => (
                                    <th
                                        key={i}
                                        className="px-2 whitespace-nowrap py-2 text-left"
                                        style={{ minWidth: 80 }}
                                    >
                                        <Skeleton width={60} height={14} />
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({ length: rows }).map((_, r) => (
                                <tr key={r}>
                                    {Array.from({ length: COLUMN_COUNT }).map((_, c) => (
                                        <td
                                            key={c}
                                            className="px-2 whitespace-nowrap py-2"
                                        >
                                            <Skeleton
                                                width={c === COLUMN_COUNT - 1 ? 90 : 60}
                                                height={c === COLUMN_COUNT - 1 ? 28 : 14}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default memo(DiamondListSkeleton);
